import { Form, Select } from 'antd';
import React, { useState } from 'react'

import Button from '../../../../components/Button/Button';
import { StateBook } from '../../../../models/books';
import FormItem from '../../../../components/FormItem/FormItem';
import { createArrayOfNumbers, getBookStateTranslatesByKey } from '../../../../utils/utils';

const { Option } = Select;

interface Props {
  onClick: (values: { state: StateBook, score: number }) => void
}

const options: { id: StateBook, label: string }[] = [
  {
    id: "abandoned",
    label: getBookStateTranslatesByKey("abandoned")
  },
  {
    id: "read",
    label: getBookStateTranslatesByKey("read")
  },
  {
    id: "reading",
    label: getBookStateTranslatesByKey("reading")
  },
  {
    id: "want",
    label: getBookStateTranslatesByKey("want")
  }
]

const AddBookToBookcaseModal = ({ onClick: addOnBookcase }:Props) => {
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState<StateBook | null>(null);

  const shouldBeShowRate = state === 'read' || state === 'abandoned'

  const handleSubmit = (values: { state: StateBook, score: number}) => {
    console.log(values)
    return addOnBookcase(values)
  }

  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit}
      id="formPreferences"
    >
      <FormItem
        label="E como está o processo de leitura?"
        name="state"
        rules={[{ required: true, message: 'Por favor, escolha uma opção!' }]}
        required>
        <Select
          onSelect={(value) => setState(value)}
          >
          {
            options?.map(states => {
              return <Option key={states.id} value={states.id}>{states.label}</Option>
            })
          }
        </Select>
      </FormItem>
      {
        shouldBeShowRate && 
      <>
        <FormItem
          label="O quanto você gostou?"
          name="score" 
          rules={[{ required: true, message: 'Por favor, escolha uma opção!' }]}
          required
          >
            <Select>
              {
                createArrayOfNumbers(1,10).map(value => {
                  return <Option key={value} value={value}>{value}</Option>
                })
              }
            </Select>
        </FormItem>
      </>
      }
      <Button
        loading={loading}
        submit>
        Confirmar!
      </Button>
    </Form>
  )
}

export default AddBookToBookcaseModal;